/**
 * Newsletter entrypoint.
 */
// JS Components
import { ComponentManager } from 'js-component-framework';
import newsletters from 'components/newsletters';

// Create instance of the component manager using `kauffman`
const manager = new ComponentManager('kauffman');
const jsComponents = [
  newsletters,
];

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents(jsComponents);
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents(jsComponents);
}

